import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {PaymentTypeEnum} from '../../../Enums';
import {mapGetters} from 'vuex';

@Component({
  computed: {
    ...mapGetters({
      userLanguage: 'getUserLanguage',
    }),
  },
})
export default class PaymentType extends Vue {
  @Prop({type: String, required: true}) paymentType: string | undefined;

  // from computed mapGetters
  private userLanguage!: string;

  get paymentTypeDisplay(): string {
    if (this.paymentType) {
      return PaymentTypeEnum[this.paymentType].title[this.userLanguage];
    }
    return 'k.A.';
  }

  get paymentTypeIcon(): string {
    return '';
  }
}
